export const READY_PCS_CONFIG = {
  readyPcsBreakpoint: 20,
  overlappedBulletColor: 'Chart/Light/Warning',
  notFinishedBulletColor: 'Background/Light/Chart',
  finishedBulletColor: 'Label/Light/Primary',
};

export const DEFAULT_BULLET_ANIMATION_DURATION = 2000;

export const DEFAULT_MIN_BULLETS_FOR_WIDTH = 8;